// app/javascript/controllers/drawer_trigger_controller.js
// Universal trigger for opening any drawer
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const drawerId = event.params.id || event.currentTarget.dataset.drawerId
    if (!drawerId) return

    document.dispatchEvent(new CustomEvent("drawer:open", {
      bubbles: true,
      detail: { drawerId }
    }))
  }
}

